export function deserialGeoReturn(data, excludePartialMatches) {
  let result_set = {
    results:[],
    result:null,
    raw: null,
    multiple: null,
    status: "ERROR"
  };
  if (data.length > 1) {
    result_set.multiple = true;
  }
  for (var i = 0; i < data.length; i++) {
    let currentResult = data[i];

      if (excludePartialMatches && excludePartialMatches === true && typeof currentResult.partial_match !== 'undefined' && currentResult.partial_match === true) {
        continue;
      }
    if (data.length > 1) {
      result_set.results.push(extractAddrObj(currentResult));
    } else {
      result_set.multiple = false;
      result_set.result = extractAddrObj(currentResult);
    }
  }
  result_set.raw = data;
  result_set.status = "OK";

  return result_set;
}

export function extractAddrObj(data) {
  let googleConfidenceLookup = {
    ROOFTOP: 1,
    RANGE_INTERPOLATED: 0.9,
    GEOMETRIC_CENTER: 0.7,
    APPROXIMATE: 0.5
  };
  let extractedObj = {
    formattedAddress: data.formatted_address || null,
    latitude: data.geometry.location.lat(),
    longitude: data.geometry.location.lng(),
    extra: {
      googlePlaceId: data.place_id || null,
      confidence: googleConfidenceLookup[data.geometry.location_type] || 0,
      premise: null,
      subpremise: null,
      neighborhood: null,
      establishment: null,
      raw: data,
    },
    administrativeLevels: {
    }
  };

  for (var i = 0; i < data.address_components.length; i++) {
    for (var x = 0; x < data.address_components[i].types.length; x++) {
      var addressType = data.address_components[i].types[x];
      switch (addressType) {
        //Country
        case 'country':
          extractedObj.country = data.address_components[i].long_name;
          extractedObj.countryCode = data.address_components[i].short_name;
          break;
        //Administrative Level 1
        case 'administrative_area_level_1':
          extractedObj.administrativeLevels.level1long = data.address_components[i].long_name;
          extractedObj.administrativeLevels.level1short = data.address_components[i].short_name;
          break;
        //Administrative Level 2
        case 'administrative_area_level_2':
          extractedObj.administrativeLevels.level2long = data.address_components[i].long_name;
          extractedObj.administrativeLevels.level2short = data.address_components[i].short_name;
          break;
        //Administrative Level 3
        case 'administrative_area_level_3':
          extractedObj.administrativeLevels.level3long = data.address_components[i].long_name;
          extractedObj.administrativeLevels.level3short = data.address_components[i].short_name;
          break;
        //Administrative Level 4
        case 'administrative_area_level_4':
          extractedObj.administrativeLevels.level4long = data.address_components[i].long_name;
          extractedObj.administrativeLevels.level4short = data.address_components[i].short_name;
          break;
        //Administrative Level 5
        case 'administrative_area_level_5':
          extractedObj.administrativeLevels.level5long = data.address_components[i].long_name;
          extractedObj.administrativeLevels.level5short = data.address_components[i].short_name;
          break;
        // City
        case 'locality':
        case 'postal_town':
          extractedObj.city = data.address_components[i].long_name;
          break;
        // Address
        case 'postal_code':
          extractedObj.zipcode = data.address_components[i].long_name;
          break;
        case 'route':
          extractedObj.streetName = data.address_components[i].long_name;
          break;
        case 'street_number':
          extractedObj.streetNumber = data.address_components[i].long_name;
          break;
        case 'premise':
          extractedObj.extra.premise = data.address_components[i].long_name;
          break;
        case 'subpremise':
          extractedObj.extra.subpremise = data.address_components[i].long_name;
          break;
        case 'establishment':
          extractedObj.extra.establishment = data.address_components[i].long_name;
          break;
        case 'sublocality_level_1':
        case 'political':
        case 'sublocality':
        case 'neighborhood':
          if(!extractedObj.extra.neighborhood) {
            extractedObj.extra.neighborhood = data.address_components[i].long_name;
          }
          break;
      }
    }
  }
  return extractedObj;
}
